import * as React from "react";
import { BooleanField, TextInput, TextField, EditButton } from "react-admin";
import { Datagrid, IfCanAccess, List } from "src/enterprise/ra-rbac";

const listFilters = [<TextInput source="search" label="Search" alwaysOn />];

export const StickerList = (props) => {
  return (
    <List {...props} filters={listFilters} queryOptions={{ cacheTime: 0 }}>
      <Datagrid>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="image" />
        <IfCanAccess action="edit">
          <EditButton />
        </IfCanAccess>
      </Datagrid>
    </List>
  );
};
